import parse from 'html-react-parser'
import Link from 'next/link'
import { React, useState } from 'react'
import dynamic from 'next/dynamic'
import Header from '../components/header'
const Footer = dynamic(() => import('../components/footer'))
const MiniCart = dynamic(() => import('../components/cart/minicart'))
import Messagesent from '../components/messagesent'
import Scripts from '../components/scripts';
import MetaTags from '../components/MetaTags'

function ContactPage({ item, menu, config }) {

  const [form_submitted, set_form_submitted] = useState(false)

  const [selected_file, set_selected_file] = useState(false)

  const upload_image_clientside = (event) => {
    let files = event.target.files;
    let reader = new FileReader();
    let fileArray=[];
    for (let file of files) {
      (function(file) {
        var reader = new FileReader();
        reader.onload = (file) => {
          fileArray.push(file.target.result);
        }
        reader.readAsDataURL(file)
      })(file);
    }
    set_selected_file(fileArray)
  }


  const submit_and_validate_form = (event) => {
    event.preventDefault()
    var chk_status = event.target.checkValidity();
    event.target.reportValidity();
    if (chk_status) {
      var result = formsmailer_api_call(event)
    }
    if (result) {
      set_form_submitted(true)
    }
  }


  const formsmailer_api_call = async (event) => {
    event.preventDefault()
    const data = new FormData(event.target);
    const form = Object.fromEntries(data.entries());

    const body_text = (form) => {
      var text = ""
      for (var key of Object.keys(form)) {
        if (key == 'upload') {
          // for(let chosenImage of selected_file){
            text += "<b>" + key + ":</b> <div style='display:none'>#image-place</div>";
          // }
          console.log("asdasdasd file=>", text)
        
        } else {
          text += ("<b>" + key + ":</b> " + " - " + form[key]) + "\n"
        }
      }
      return text
    }
    
    // send the email as the email and the name at the remote end
    const res = fetch(
      process.env.NEXT_PUBLIC_API_URL + '/formsmailer',
      {
        body: JSON.stringify({
          images: selected_file,
          body: body_text(form),
          subject: 'Part Identification',
          reply_to: form.email,
          device_name: 'browser'
        }),
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      }
    )
      .then(response => {
        // reject not ok response
        if (!response.ok) {
          return Promise.reject(response)
        }
        return response.json() // or return response.text()
      })
      .catch(async response => {
        const error = await response.json().then(text => text)
        return Promise.reject(error)
      })
      .then(data => {
        return true
      })
      .catch((error) => {
        console.warn(error);
      });

  }


  return (
    <>
      <MetaTags item={item} config={config}></MetaTags>
      <div className="wrapper h-full flex flex-col">
        <Header menu={menu} config={config}></Header>
        <section className="content flex flex-grow flex-col">

          <div className="hidden lg:block container mx-auto text-xs py-2 px-5 lg:px-0">
            <div className="space-x-2 flex items-center leading-none">
              <Link href="/">
                <a title="Home">
                  <i className="fas fa-home text-brand-tertiary"></i>
                </a>
              </Link>
              <span className="text-gray-400">/</span>
              <span className="text-gray-600">Part Identification</span>
            </div>
          </div>

          <div className="bg-gray-100 py-8 lg:py-16">
            <div className="container mx-auto lg:mb-4">
              <div className="flex justify-center">
                <div className="lg:w-8/12">


                  {(form_submitted) ? (
                    <Messagesent></Messagesent>
                  ) : (
                    <>
                      <div className="w-full lg:w-3/5 mx-auto">

                        <div className="mb-6">
                          {(item && item.description) ? (
                            parse(item.description)
                          ) : ('')}
                        </div>

                        <form method="post" onSubmit={(event) => submit_and_validate_form(event)} className="bg-white rounded-lg shadow p-5 lg:p-8">
                          <p className="text-gray-600 text-base font-normal mb-3"><small>Fields marked with an asterix (<span className="text-red-600">*</span>) are required.</small></p>
                          <div className="mb-4">
                            <label className="field-label">
                              <span className="label-text">Your Name <span className="text-red-600">*</span></span>
                              <input type="" name="name" placeholder="Enter your full name" required className="input-field w-full" />
                            </label>
                          </div>
                          <div className="mb-4">
                            <label className="field-label">
                              <span className="label-text">Company Name</span>
                              <input type="" name="company" placeholder="(optional)" className="input-field w-full" />
                            </label>
                          </div>
                          <div className="mb-4">
                            <label className="field-label">
                              <span className="label-text">E-Mail Address <span className="text-red-600">*</span></span>
                              <input type="email" name="email" required placeholder="Where we will send a response" className="input-field w-full" />
                            </label>
                          </div>
                          <div className="mb-4">
                            <label className="field-label">
                              <span className="label-text">Phone Number</span>
                              <input type="" name="phone" placeholder="Used to call you back (optional)" className="input-field w-full" />
                            </label>
                          </div>
                          <div className="mb-4">
                            <label className="field-label">
                              <span className="label-text">Photo Upload</span>
                              <input onChange={(event) => upload_image_clientside(event)} id="upload" multiple name="upload" className="px-4 text-gray-600 rounded block w-full cursor-pointer bg-white border border-gray-300 hover:border-brand-secondary active:border-brand-tertiary transition-all focus:text-gray-800 focus:outline-none focus:border-brand-tertiary focus:ring-2 focus:ring-inset focus:ring-brand-tertiary" aria-describedby="upload_help" type="file" accept="image/*"></input>
                              <div className="mt-1 text-sm font-normal text-gray-600" id="upload_help">Accepted file types include: .JPG, .PNG and .GIF</div>
                            </label>
                          </div>
                          <div className="mb-4">
                            <label className="field-label">
                              <span className="label-text">Details <span className="text-red-600">*</span></span>
                              <textarea name="query" required placeholder="Please provide as much information as you can about the part you need help identifying" cols="6" rows="6" className="input-field w-full"></textarea>
                            </label>
                          </div>
                          <button className="btn btn-primary btn-lg">Send</button>
                        </form>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer menu={menu} config={config}></Footer>
      </div>
      <MiniCart></MiniCart>
      <Scripts javascripts={item.javascripts}></Scripts>
    </>
  )
}


// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps(context) {
  const config_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/configs')
  const config_data = await config_res.json()
  const config = config_data.data

  const menu_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/menu')
  const menu = await menu_res.json()

  const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/landingpage/part-identification')
  const response = await res.json()
  const page = response.data


  return {
    props: {
      config: config,
      menu: menu,
      item: page,
    },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: 600, // In seconds

  }
}


export default ContactPage
